<div #productOverviewRef>
  <app-breadcrumb [categoryId]="(category$ | async)?.id" #breadcrumbRef></app-breadcrumb>
  <div class="product-overview">
    <app-filter-menu [categoriesTitle]="filterMenu.categoryTitle" [allProducts]="filterMenu.allProducts"></app-filter-menu>
    @if (!isDiningSix || (category$ | async)?.id) {
      <app-text-button class="filter-button" (click)="openFilterMenu()">{{ openCategoriesMenu }}</app-text-button>
    }
    @let loading = loading$ | async;
    <div class="product-overview-content">
      @if (enableSearch) {
        <div class="search-bar" [class.hidden]="(category$ | async) !== undefined">
          <input #searchInput type="search" [placeholder]="searchPlaceholder" [(ngModel)]="searchTerm" name="product-search" />
          @if (searchTerm) {
            <app-icon-button buttonType="button" [icon]="clearIcon" [border]="false" (click)="clearSearch(true)"></app-icon-button>
          }
        </div>
      }
      @if ((category$ | async) === undefined && categories$ | async; as categories) {
        @if (categories.length > 0) {
          <div class="product-overview-header category-title">
            <div class="title">
              <h2>{{ filterMenu.categoryTitle }}</h2>
            </div>
          </div>
        }
        @if (categories.length) {
          <ul class="category-cards unstyled">
            @if (allProductsCategoryCard) {
              <a (click)="scroll(target, $event)" href="#">
                <span class="label">{{ allProductsCategoryCard }}</span>
                <div class="image-gradient all" aria-hidden="true">
                  <img class="fill" alt="" />
                </div>
              </a>
            }
            @for (category of categories; track category.id) {
              <a (click)="clickCategory($event)" [routerLink]="getCategoryUrl(category.id)">
                <span class="label">{{ category.name }}</span>
                <div class="image-gradient" aria-hidden="true">
                  @if (category.imageUrl) {
                    <img [src]="cmsOrigin + category.imageUrl" alt="" />
                  }
                  @if (!category.imageUrl) {
                    <img class="fill" alt="" />
                  }
                </div>
              </a>
            }
          </ul>
        }
      }
      <div class="product-overview-header" #target>
        @let category = category$ | async;
        <div class="title">
          @if (!category && allProductsTitle) {
            <h1>{{ allProductsTitle }}</h1>
          }
          @if (category) {
            <h1>{{ category.title || category.name }}</h1>
          }
          @if (category || allProductsTitle) {
            <span>{{ pageTotal$ | async }} varer</span>
          }
        </div>
      </div>
      <div
        infiniteScroll
        [infiniteScrollDistance]="3"
        [infiniteScrollThrottle]="50"
        [infiniteScrollDisabled]="reset"
        class="product-overview-cards"
      >
        @for (product of products$ | async; track product.id) {
          <app-product-card
            [@searchItemAnimation]
            [product]="product"
            [showBasketIcon]="showBasketIcon"
            [big]="isDiningSix && isMobile"
          ></app-product-card>
        }
      </div>
      @if (!loading && pageTotal$ | async; as pageTotal) {
        @let pageShowing = pageShowing$ | async;
        <span class="currently-showing">
          Viser {{ pageShowing > pageTotal ? pageTotal : pageShowing }} ud af {{ pageTotal }} produkter
        </span>
        @if (hasMore() && pageSize$ | async; as pageSize) {
          <app-text-button class="load-more" (click)="loadMore()">
            Vis næste {{ pageTotal - pageShowing < pageSize ? pageTotal - pageShowing : pageSize }} produkter
          </app-text-button>
        }
      }
      @if (loading) {
        <div class="loading">
          <img src="assets/preloader.gif" [alt]="loadingProductsAlt" />
        </div>
      }
    </div>
  </div>
</div>
@if ((category$ | async)?.description; as description) {
  <div [innerHTML]="description | sanitizeHtml" class="description rich-text"></div>
}

<app-icon-button
  class="scroll-to-top"
  [@showHide]="showScrollToTop ? 'show' : 'hide'"
  [icon]="arrowIcon"
  [smallIcon]="true"
  (click)="scroll(productOverviewRef)"
></app-icon-button>
